export default "__VITE_ASSET__C58SxVsh__"